import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import OneLineCardSkeleton from "../components/SkeletonCards/OneLineCardSkeleton";
import useFetch from "../hooks/useFetch";
import PerformanceCard from "../components/PerformanceCard";

const Performances: React.FC = () => {
  //const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorMessage] = useState<string | null>(null);

  const navigate = useNavigate();
  const params = useParams<{ division_id: string }>();
  const division_id = params?.division_id;

  const {
    fetchData,
    data: performances,
    errorContent,
    isLoading,
    hasFetched,
  } = useFetch({
    url: `${
      import.meta.env.VITE_API_URL
    }/performances/by-division-id?division_id=${division_id}`,
    method: "GET",
  });

  useEffect(() => {
    if (division_id) {
      fetchData();
    }
  }, [division_id]);

  if (errorContent) return errorContent;
  
  if (!hasFetched) {
    return null; // Prevent rendering until fetch is complete
  }

  return (
    <>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      <section className="headersection2">
        <div className="w-layout-blockcontainer container-main-content w-container">
          <div className="div-header-title-section">
            <div
              className="link-block w-inline-block cursor-pointer"
              onClick={() =>
                navigate(`/divisions/${performances?.division?.event_id}`)
              }
            >
              <img
                src="/images/back-icon.png"
                loading="lazy"
                alt=""
                className="image-2"
              />
              <h1 className="back-text-link">
                {performances?.division?.event_location}
              </h1>
            </div>
            <h1 className="judgingapp-heading2" onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}>
              {performances?.division?.division_title.split('_')[0]}
            </h1>
            <p className="paragraph-2">
              {performances?.division?.start_time} -
              {performances?.division?.end_time}
            </p>
          </div>
        </div>
      </section>
      <section style={{backgroundColor: 'white'}}>
        <div className="performance-container">
          {isLoading ? (
            <OneLineCardSkeleton
              cardsCount={2}
              baseColor="#d3ddf3"
              highlightColor="#fff"
            />
          ) : (
            <div className="performance-table">
              <div className="performance-table-row-performance-admin performance-table-header">
                <div className="item-1">Entry</div>
                <div className="item-2">Program/Performer</div>
                <div className="item-3"></div>
                <div className="item-4">Routine</div>
                <div className="item-5">Total</div>
                <div className="item-6" style={{ marginLeft: '15px' }}>Placement</div>
                <div className="item-7"></div>
              </div>
              
              {performances?.performances?.map((performance: any) => {
                //const performanceColor = performance?.color_code === 1 ? "performance--yellow" : "performance--grey";
                const performanceColor = performances?.settings_color_code?.value?.[performance.performance_type][performance.color_code];
                return (
                  <PerformanceCard
                    key={performance.id}
                    id={performance.id}
                    type={"judge"}
                    division={performance?.divisions_performance_group?.title}
                    performanceColor={performanceColor}
                    entry_number={performance?.entry}
                    performance_type={performance.performance_type}
                    performers={performance.performers}
                    program={performance.program}
                    routine={performance?.routine}
                    secondLastColumn={performance?.total_score}
                    lastColumn={performance?.ranking}
                    is_editing_allowed={performance?.is_editing_allowed}
                    ranking_final_score={0}
                    fetchData={fetchData}
                    event_id={performances?.division?.event_id}
                    talktape={performance?.talktape}
                  />
                );
              })}
            </div>
          )}
        </div><br/>
      </section>
    </>
  );
};

export default Performances;
